/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "date-picker"
};
import Screen from './Screen.vue';
import { EDateType } from '@/interface';
import { DAYJS_FORMAT, DATE_TAB_MAP } from '@/config/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  emits: ["confirm-date"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var active = ref(EDateType.day);
    var typeTabMap = reactive(DATE_TAB_MAP);
    function confirmScreen(data) {
      var startTime = data.startTime.format(DAYJS_FORMAT.YYYYMMDD_HHMMSS);
      var endTime = data.endTime.format(DAYJS_FORMAT.YYYYMMDD_HHMMSS);
      emit('confirm-date', {
        startTime: startTime,
        endTime: endTime
      });
    }
    return function (_ctx, _cache) {
      var _component_van_tab = _resolveComponent("van-tab");
      var _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default"), _createVNode(_component_van_tabs, {
        type: "card",
        active: _unref(active),
        "onUpdate:active": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(active) ? active.value = $event : null;
        }),
        class: "date-picker-tabs"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeTabMap), function (value, key) {
            return _openBlock(), _createBlock(_component_van_tab, {
              key: key,
              title: value,
              name: Number(key),
              "title-class": "date-picker-tabs-title"
            }, null, 8, ["title", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["active"]), _createVNode(Screen, {
        active: _unref(active),
        onConfirmScreen: confirmScreen
      }, null, 8, ["active"]), _renderSlot(_ctx.$slots, "bottom-extension")]);
    };
  }
});